import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './AdminOrderDetails.css';

function AdminOrderDetails() {

    const { orderId } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [order, setOrder] = useState(state?.order || null);
    const [loading, setLoading] = useState(!state?.order);
    const [error, setError] = useState(null);

    // If we receive order via state, use it directly
    useEffect(() => {
        if (state?.order) {
            setOrder(state.order);
            setLoading(false);
        }
    }, [state?.order]);

    // useEffect(() => {
    //     // Only fetch if we didn't receive order via state
    //     if (!state?.order) {
    //         const fetchOrderDetails = async () => {
    //             try {
    //                 const { data } = await axios.get(
    //                     `http://localhost:3001/orders/${orderId}`,
    //                     { withCredentials: true }
    //                 );
    //                 setOrder(data);
    //             } catch (error) {
    //                 console.error("Failed to fetch order:", error);
    //                 setError(error.response?.data?.error || "Failed to load order details");
    //             } finally {
    //                 setLoading(false);
    //             }
    //         };
    //         fetchOrderDetails();
    //     }
    // }, [orderId, state?.order]);

    const updateStatus = async (newStatus) => {
        if (!order) return;
        
        try {
            await axios.put(
                `http://localhost:3001/admin/orders/${order._id}`,
                { status: newStatus },
                { withCredentials: true }
            );

            // Update local state immediately for better UX
            setOrder(prev => ({
                ...prev,
                trackingStatus: newStatus,
                updatedAt: new Date().toISOString()
            }));
            
        } catch (error) {
            console.error("Failed to update order:", error);
            setError("Failed to update order status");
        }
    };


    if (loading) return <div className="loading-spinner">Loading...</div>;
    if (error) return <div className="error-message">{error}</div>;
    if (!order) return <div className="no-orders">No order found</div>;


    return (
        <div className="admin-order-details">
            <div className="header">
                <h2>Order Details</h2>
                <button onClick={() => navigate(-1)} className="back-button">
                    Back to Dashboard
                </button>
            </div>

            <div className="order-summary">
                <div className="summary-card">
                    <h3>Order Information</h3>
                    <p><strong>Order ID:</strong> {order._id}</p>
                    <p><strong>Date:</strong> {new Date(order.createdAt).toLocaleString()}</p>
                    <p><strong>Status:</strong>
                        <select
                            value={order.trackingStatus}
                            onChange={(e) => updateStatus(e.target.value)}
                            className="status-select"
                        >
                            <option value="Order Placed">Order Placed</option>
                            <option value="Dispatched">Dispatched</option>
                            <option value="In Transit">In Transit</option>
                            <option value="Out for Delivery">Out for Delivery</option>
                            <option value="Delivered">Delivered</option>
                        </select>
                    </p>
                    <p><strong>Total Amount:</strong> ₹{order.total.toFixed(2)}</p>
                </div>

                <div className="summary-card">
                    <h3>Customer Information</h3>
                    <p><strong>Name:</strong> {order.shippingAddress.name}</p>
                    <p><strong>Email:</strong> {order.userEmail || 'N/A'}</p>
                    <p><strong>Phone:</strong> {order.shippingAddress.phone}</p>
                    <p><strong>Address:</strong> {order.shippingAddress.address}, {order.shippingAddress.city}, {order.shippingAddress.state} - {order.shippingAddress.pincode}</p>
                </div>
            </div>

            <div className="order-items">
                <h3>Ordered Items</h3>
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {order.items.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="product-info">
                                        <img
                                            src={item.image || '/placeholder-product.jpg'}
                                            alt={item.name}
                                            className="product-image"
                                        />
                                        <div>
                                            <p className="product-name">{item.name}</p>
                                            {item.size && <p className="product-variant">Size: {item.size}</p>}
                                            {item.color && <p className="product-variant">Color: {item.color}</p>}
                                        </div>
                                    </div>
                                </td>
                                <td>₹{item.price.toFixed(2)}</td>
                                <td>{item.quantity}</td>
                                <td>₹{(item.price * item.quantity).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="order-totals">
                <div className="totals-card">
                    <h3>Payment Information</h3>
                    <p><strong>Payment Method:</strong> {order.paymentMethod}</p>
                    <p><strong>Payment Status:</strong>
                        <span className={`payment-status ${order.paymentStatus.toLowerCase()}`}>
                            {order.paymentStatus}
                        </span>
                    </p>
                    <div className="amount-breakdown">
                        <p><span>Subtotal:</span> <span>₹{order.subtotal?.toFixed(2) || order.total.toFixed(2)}</span></p>
                        {order.discount > 0 && (
                            <p><span>Discount:</span> <span>-₹{order.discount.toFixed(2)}</span></p>
                        )}
                        <p><span>Shipping:</span> <span>₹{order.shippingFee?.toFixed(2) || '0.00'}</span></p>
                        <p className="total-amount"><span>Total:</span> <span>₹{order.total.toFixed(2)}</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminOrderDetails